export default __webpack_public_path__ + "e89ff27869433f5cae3f7db8fdb759a2.png";